<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2 v-show="!trash">Trucks</h2>
        		<h2 v-show="trash">Trucks - Trash</h2>
			</b-col>
		</div>
		<div class="card">
			<div class="card-body">
				<b-row>
					<b-container fluid>
						<div class="row">
							<b-col lg="4" md="6" xs="12" class="my-1">
								<div class="input-group mb-3">
									<div class="input-group-prepend">
										<b-form-input v-model="filter" placeholder="Search" />
										<b-btn class="brad-0" :disabled="!filter" @click="filter = ''">Clear</b-btn>
									</div>
								</div>
							</b-col>
							<b-col v-if="role==='super_admin' || role==='trucking_company_admin' || role==='trucking_operational_manager'" lg="3" class="my-1">
								<b-dropdown class="pull-left" :text="dpdt">
									<b-dropdown-item @click="trashTrucks()">Active</b-dropdown-item>
									<b-dropdown-item @click="trashTrucks()">Trash</b-dropdown-item>
								</b-dropdown>
							</b-col>
							<b-col lg="5" md="6" xs="12">
								<b-button :disabled="!insert_data" @click="newTruckModal" variant="primary" class="active mb-3 pull-right">Add Truck</b-button>
							</b-col>
						</div>

						<b-row v-if="loadingData">
							<b-col cols="12" sm="12" md="12" lg="12">
								<p class="text-center">
									<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
								</p>
							</b-col>
						</b-row>
						<b-table class="animated fadeIn" v-else striped hover bordered show-empty stacked="md" :items="items" :fields="fieldsTh" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered"
						  @row-clicked="rowClicked">

						</b-table>
						<!-- User Interface controls -->
						<b-row>
							<b-col lg="2" md="2" sm="12" class="my-1 pull-left">
								<div class="input-group mb-3">
									<div class="input-group-prepend"> </div>
									<b-select :options="pageOptions" v-model="perPage" />
								</div>
							</b-col>
							<b-col lg="10" md="10" sm="12" class="my-1 pull-right">
								<b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
							</b-col>
						</b-row>
						<!-- Info modal -->
						<b-modal id="modalInfo" @hide="resetModal" :title="modalInfo.title" ok-only>
							<pre>{{ modalInfo.content }}</pre>
						</b-modal>
						<!--End ModalInfo-->
					</b-container>
				</b-row>
			</div>
		</div>
		<!-- New Truck Modal-->
		<b-modal title="New Truck" v-model="newTruck" hide-header-close no-close-on-backdrop no-close-on-esc>
			<b-row>
				<b-col cols="12">
					<b-form-group :label-cols="4" id="L1" label="Truck Name:" label-for="trucknameID" horizontal>
						<b-form-input id="trucknameID" type="text" v-model="model.truck_name"></b-form-input>
					</b-form-group>
					<b-form-group v-show="view" :label-cols="4" id="L4" label="Trucking Company:" label-for="truckingCompanyID" horizontal>
						<b-form-select value-field="id" text-field="trucking_company" id="truckingCompanyID" v-model="model.trucking_company_id" :options="truckingcompaniesselect"/>
					</b-form-group>
					<b-form-group :label-cols="4" id="L4" label="Truck Type:" label-for="truckTypeID" horizontal>
						<b-form-select value-field="id" text-field="type" id="truckTypeID" v-model="model.truck_type_id" :options="trucktypesselect"/>
					</b-form-group>
				</b-col>
			</b-row>
			<div slot="modal-footer" class="w-100">
				<b-btn size="md" variant="secondary" @click="newTruck=false" class="float-left">Cancel</b-btn>
				<b-btn :disabled="savebtn" size="md" variant="primary" @click="saveNewTruck" class="float-right">Save</b-btn>
			</div>
		</b-modal>
		<!-- End New Truck Modal-->
		<!-- Table Config-->
		<b-modal title="Config Table" v-model="configTable" ok-variant="primary">
			<b-row>
				<b-col cols="12">
					<b-form-checkbox-group stacked id="basicCheckboxes" name="Checkboxes" :plain="true" :checked="selectedItems">
						<b-form-checkbox value="id" :disabled="true">Truck ID</b-form-checkbox>
						<b-form-checkbox value="truck_name" :disabled="true">Truck Name</b-form-checkbox>
						<b-form-checkbox value="plate_truck" :disabled="true">Plate Truck</b-form-checkbox>
						<b-form-checkbox value="type" @change="actionField('type')">Type</b-form-checkbox>
						<b-form-checkbox value="trucking_company" @change="actionField('trucking_company')">Trucking Company</b-form-checkbox>
						<b-form-checkbox value="create_at" @change="actionField('create_at')">Created</b-form-checkbox>
					</b-form-checkbox-group>
				</b-col>
			</b-row>
		</b-modal>
		<!-- Table Config-->
	</div>
</template>

<script>
	import trucks_service from './trucks_service'
	import tc_service from '../trucking_companies/tc_service'
	import vSelect from 'vue-select'
	const items = []
	const truckingCompanies = []
	const typeTrucks = [{
		value: '1',
		label: 'Pequeño'
	}, {
		value: '2',
		label: 'Mediano'
	}, {
		value: '3',
		label: 'Grande'
	}]
	const fields = ['truck_name', 'trucking_company', 'type']
	export default {
		name: 'truck',
		created: function() {
			this.getAll()
			localStorage.removeItem("haulsaPage");
			localStorage.removeItem("targetsaPage");
			localStorage.removeItem("ftPage");
			localStorage.removeItem("targetPage");
			localStorage.removeItem("tpPage");
			localStorage.removeItem("oaPage");
			localStorage.removeItem("reportPage");
			localStorage.removeItem("rolesPage");
			localStorage.removeItem("servicePage");
			localStorage.removeItem("truckuserPage");
			localStorage.removeItem("tcPage");
			localStorage.removeItem("locationPage");
			localStorage.removeItem("taPage");
			localStorage.removeItem("tasaPage");
			if (!localStorage.truckPage) {
					localStorage.truckPage = 0;
			}
		},
		components: {
			vSelect
		},
		data() {
			return {
				insert_data: null,
				trash: false,
				dpdt: 'Active',
				model: {
					truck_name: '',
					trucking_company_id: '',
					truck_type_id: '',
				},
				truckingcompaniesselect: [],
				trucktypesselect: [],

				truckName: '',
				truckId: null,
				plateTruck: '',
				selectedTC: null,
				truckingCompanies: [],
				selectedType: null,
				typeTrucks: typeTrucks,
				newTruck: false,
				items: items,

				loadingData: true,
				currentPage: parseInt(localStorage.truckPage),
				perPage: 25,
				totalRows: items.length,
				pageOptions: [25, 50, 100],
				sortBy: 'truck_name',
				sortDesc: false,
				fields: fields,
				modalEdit: {
					title: ''
				},
				fieldsTh: [
					{
						key: 'id',
						label: 'ID',
						sortable: true
					},
					{
						key: 'truck_name',
						label: 'Truck Name',
						sortable: true
					},
					{
						key: 'type',
						label: 'Type'
					},
					{
						key: 'trucking_company',
						label: 'Trucking Company'
					},
				],
				filter: null,
				modalInfo: {
					title: '',
					content: ''
				},
				configTable: false,
				selectedItems: ['truck_name', 'type', 'trucking_company'],
				savebtn:true,
				role:'',
				view:true,
				trucking_company_id:''
			}
		},
		computed: {
			sortOptions() {
				// Create an options list from our fields
				return this.fieldsTh
					.filter(f => f.sortable)
					.map(f => {
						return {
							text: f.label,
							value: f.key
						}
					})
			}
		},
		methods: {
			newTruckModal() {
				this.model = {
					truck_name: '',
					trucking_company_id: '',
					truck_type_id: '',
				}
				this.savebtn=false
				this.newTruck = true
			},
			rowClicked(row) {
				localStorage.truckPage = this.currentPage;
				if (!this.trash) {
					this.$router.push('/truck/' + row.id + '/')
				} else {
					this.restoreTruck(row.id)
				}
			},
			actionField(option) {
				var fieldsThLength = this.fieldsTh.length
				var fieldIsActive = false
				for (var i = 0; i <= fieldsThLength; i++) {
					fieldIsActive = true
					try {
						if (this.fieldsTh[i].key === option || this.fieldsTh[i] === option) {
							this.fieldsTh.splice(i, 1)
							fieldIsActive = false
							break
						}
					} catch (err) {
						var position = this.fields.indexOf(option)
						this.fieldsTh.splice(position, 0, option)
					}
				}
			},
			onFiltered(filteredItems) {
				// Trigger pagination to update the number of buttons/pages due to filtering
				this.currentPage = parseInt(localStorage.truckPage)
				this.totalRows = filteredItems.length
				this.currentPage = 1
			},
			trashTrucks() {
				this.trash = !this.trash
				this.dpdt = this.trash ? "Trash" : "Active"
				this.getAll()
				this.loadingData = true
			},
			resetModal() {
				this.modalInfo.title = ''
				this.modalInfo.content = ''
			},
			getAll() {
				this.loadingData = true
				trucks_service.getAll()
					.then(data => {
						if (data[0] == 'success') {
							this.items = data[1].filter(o => o.status_id == (this.trash ? 2 : 1))
							this.insert_data = data[2]
							this.trucktypesselect = this.insert_data.truck_types
							this.truckingcompaniesselect = this.insert_data.trucking_companies
							this.role = data[3]
  							if (this.role =='super_admin') {
  								this.view=true
  							} else if (this.role =='super_analyst' || this.role =='analyst' || this.role =='marketing_accountant') {
  								this.view=false
  							} else if (this.role =='trucking_company_admin' || this.role==='trucking_operational_manager') {
								  this.view=false
								  this.trucking_company_id = data[4]
              				}
						} else {
							this.items = []
							this.$swal(data[0], data[1], data[0])
						}
						this.loadingData = false
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
			saveNewTruck() {
				if (!this.okToSave()) {
					return
				}
				this.savebtn=true
				if (this.role =='trucking_company_admin' || this.role === 'trucking_operational_manager') {
					this.model.trucking_company_id = this.trucking_company_id
				}
				var dataTruck = {
					truck_name: this.model.truck_name,
					trucking_company_id: this.model.trucking_company_id,
					truck_type_id: this.model.truck_type_id
				}

				trucks_service.save(dataTruck)
					.then(data => {
						this.$swal(data[0], data[1], data[0])
							.then((result) => {
								if (data[0] == 'success') {
									this.newTruck = false
									this.getAll()
								}
							})
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					})
					this.savebtn=false
			},
			okToSave() {
				if (this.role =='super_admin') {
					if(this.model.trucking_company_id === undefined || this.model.trucking_company_id.length == 0) {
							this.$swal('Alert!', 'Trucking Company not selected', 'warning')
							return false
					}
				}
				if (this.model.truck_name === undefined || this.model.truck_name.trim().length == 0) {
					this.$swal('Alert!', 'Truck Name can not be empty', 'warning')
					return false
				} else if (this.model.truck_type_id === undefined || this.model.truck_type_id.length == 0) {
					this.$swal('Alert!', 'Truck Type not selected', 'warning')
					return false
				}

				return true
			},
			restoreTruck(id) {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to restore this Truck?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						trucks_service.restore(id)
							.then(data => {
								this.$swal(data[0], data[1], data[0])
								if (data[0] == 'success') {
									this.filter = ''
									this.trash = false
									this.getAll()
									this.loadingData = true
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/trucks/trucks.vue